export default {"src":"/_next/static/media/heading_icon.23221909.svg","height":49,"width":47,"blurWidth":0,"blurHeight":0};